import { render, staticRenderFns } from "./ContainerRight.vue?vue&type=template&id=1b28ca3c&scoped=true"
var script = {}
import style0 from "./ContainerRight.vue?vue&type=style&index=0&id=1b28ca3c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b28ca3c",
  null
  
)

export default component.exports